import { QuestionAddressBlock } from 'components/Questionnaires/blocks';

export function residentAddressBlock() {
  return {
    id: 'address',
    title: 'questionnaire.address',
    component: QuestionAddressBlock,
    info: {
      instructions: 'questionnaire.address.1.info'
    },
    visible: true,
    lockGroup: 'permanentAddress',
  };
}

export default residentAddressBlock;
